export default {"src":"/_next/static/media/level_8.5a7b7219.svg","height":128,"width":130,"blurWidth":0,"blurHeight":0};